module.exports = __webpack_public_path__ + "static/media/in_a_week_12.ae3478c8.jpg";